const NAV_ITEM_ACTIVE = 'list-group-item-secondary';

const Inbox = {
  create(node) {
    this.node = node;
    this.navigation = this.node.querySelector('.js-inbox-navigation');
    this.createListeners();
  },

  /**
   * Create event listeners
   * @return {void}
   */
  createListeners() {
    $(this.node).on('click', '.js-inbox-notification', (e) => {
      e.preventDefault();

      this.changeActiveItem(e.currentTarget);

      this.loadMessage(e.currentTarget.href)
        .then(this.retrieveMessageFragment)
        .then(this.outputMessage.bind(this));

      this.setURL(e.currentTarget.href);
    });
  },

  /**
   * Load message from backend
   * @param {string} url
   * @returns {Promise}
   */
  loadMessage(url) {
    return window.axios.get(url);
  },

  /**
   * Extract message part of the HTML response
   * @param {object} res
   * @returns {string}
   */
  retrieveMessageFragment(res) {
    const $element = $(res.data);
    return $element.find('.js-inbox-message').html();
  },

  /**
   * Output message HTML to the DOM
   * @param {string} html
   * @return {void}
   */
  outputMessage(html) {
    $(this.node).find('.js-inbox-message').html(html);
  },

  /**
   * Set the active message in the navigation
   * @param {HTMLElement} item
   * @return {void}
   */
  changeActiveItem(item) {
    $(this.navigation).find(`.${NAV_ITEM_ACTIVE}`).removeClass(NAV_ITEM_ACTIVE);
    $(item).parent().addClass(NAV_ITEM_ACTIVE);
    this.setIconToRead(item);
  },

  /**
   * Change icon of active item
   * @param {HTMLElement} item
   * @return {void}
   */
  setIconToRead(item) {
    const icon = item.querySelector('.fa-envelope');

    if (!icon) {
      return;
    }

    icon.className = icon.className.replace('fa-envelope', 'fa-envelope-open');
    icon.className = icon.className.replace('text-success', 'text-muted');
  },

  /**
   * Change the URL
   * @param {string} url
   * @return {void}
   */
  setURL(url) {
    if (typeof window.history === 'undefined' || typeof window.history.replaceState !== 'function') {
      return;
    }

    window.history.replaceState(null, null, url);
  },
};

export default Inbox;
